import { useQuery } from "react-query";
import API from "../../config/axios";
import { QUERY_KEY } from "../../constans/query-keys";

const fetchTodaysOnlineQueueInfo = async () => {
  const { data } = await API.get("/queues/getTodaysOnlineQueueInfo");
  return data;
};

const useGetTodaysOnlineQueueInfo = (options = {}) => {
  return useQuery(
    [QUERY_KEY.GET_TODAYS_ONLINE_QUEUE_INFO],
    fetchTodaysOnlineQueueInfo,
    options,
  );
};

export default useGetTodaysOnlineQueueInfo;
